export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#203864] text-white border-t-2 border-[#843C0C]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_17c8e741-804b-4e75-8d95-781b145a12b3/artifacts/8b00gu4c_Nexora%20PNG.png"
                alt="Nexora"
                className="h-12 w-12 object-contain invert"
              />
              <div>
                <div className="font-mono-tech text-[10px] tracking-[0.32em] text-[#FCD7C5]">
                  NEXORA
                </div>
                <div className="font-semibold tracking-tight">PRODUCTOS</div>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-md">
              Comercializadora de equipos electrónicos, logística y ventas — el puente
              directo entre la innovación global y el mercado local.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-tech text-[10px] tracking-[0.32em] uppercase text-[#FCD7C5] mb-4">
              Navegación
            </div>
            <ul className="space-y-2 text-sm">
              {[
                ["Inicio", "#inicio"],
                ["Atractivos", "#atractivos"],
                ["Metodología", "#metodologia"],
                ["Servicios", "#servicios"],
                ["Testimonios", "#testimonios"],
                ["Contacto", "#contacto"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    href={h}
                    className="text-white/80 hover:text-[#FCD7C5] transition-colors"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-tech text-[10px] tracking-[0.32em] uppercase text-[#FCD7C5] mb-4">
              Contacto
            </div>
            <ul className="space-y-2 text-sm text-white/80">
              <li>Esteban Alatorre 1288-A int. 3</li>
              <li>San Juan Bosco C.P. 44730</li>
              <li>Guadalajara, Jalisco, México</li>
              <li className="pt-2">
                <a
                  href="tel:3321747329"
                  className="hover:text-[#FCD7C5] transition-colors"
                  data-testid="footer-phone"
                >
                  3321747329
                </a>
              </li>
              <li>
                <a
                  href="mailto:contacto@nexoraproductos.com"
                  className="hover:text-[#FCD7C5] transition-colors"
                  data-testid="footer-email"
                >
                  contacto@nexoraproductos.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-white/50">
            © {year} NEXORA PRODUCTOS · Todos los derechos reservados
          </div>
          <div className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-white/50">
            nexoraproductos.com
          </div>
        </div>
      </div>
    </footer>
  );
};
